<template>
  <div class="home contenido aviso">
    <div class="container">
    <HelloWorld 
        msg="Información Legal"
        :imagen="imagen"
     />
     <Titulo titulo="Información Legal" />
     <div class="row m-0 mb-5 justify-content-center">
        <div class="col-10 my-5">
            <ol>
                <li>Dependiendo del servicio y de acuerdo a los contenidos a los que se acceda, el suministro de información solicitada podrán ser de carácter voluntario u obligatorio y serán utilizados para la prestación de servicios que corresponda, así como para el trámite de solicitudes y gestión, de cara a las compañías aseguradoras aquí citadas, estudios , realización de encuestas, así como el envío de información comercial, publicitaria y promocional por cualquier medio, referida a seguros, productos financieros, de automóviles, ocio y consumo, de terceros, siempre y cuando el Usuario no se oponga a dichas comunicaciones y acepte las condiciones, en la forma establecida para cada caso concreto.</li>
                <li>En Ramirez Asesores hemos implantado niveles de seguridad de protección de datos requeridos y han instalado todos los medios y medidas al objeto de evitar su pérdida, mal uso, alteración y acceso no autorizado. No obstante ello, el Usuario debe ser consciente de que las medidas de seguridad en Internet no son inexpugnables. Consecuentemente, Ramirez Asesores no garantiza que terceros no autorizados y actuando ilegítimamente, puedan tener conocimiento de la clase, condiciones, características y circunstancias del uso que los Usuarios hacen del Portal y de los Servicios Ofrecidos por la misma y NO SE RESPONSABILIZA POR LOS DAÑOS Y PERJUICIOS DE TODA NATURALEZA QUE PUDIERAN DEBERSE AL CONOCIMIENTO QUE PUEDAN TENER TERCEROS NO AUTORIZADOS, ACTUANDO ILEGÍTIMAMENTE, ACERCA DE LA CLASE, CONDICIONES, CARACTERÍSTICAS Y CIRCUNSTANCIAS DE LA UTILIZACIÓN O USO QUE LOS USUARIOS HACEN DEL PORTAL Y DE LOS SERVICIOS CITADOS.</li>
                <li>Al acceder a esta Web se acepta que Ramirez Asesores no será responsable de consecuencia alguna, daño o perjuicio que se deriven de dicho acceso o uso de la información de dicha Web o por el acceso a otras materias en Internet a través de las conexiones con esta Web.</li>
                <li>El Copyright del material contenido en esta Web esta debida mente registrado por las aseguradoras correspondientes. El acceso a él no implica licencia para su reproducción y/ o distribución y no está permitido hacerlo sin el previo consentimiento de Ramirez Asesores y/o la aseguradora correspondiente.</li>
                <li>La información contenida en esta página, ligas de interés y relacionadas con la misma, tienen el carácter solamente de informativa y puede variar sin previo aviso en relación a los productos, contratos, requerimientos y avisos de las aseguradoras aquí descrita.</li>
            </ol>
        </div>
     </div>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/fondoAzul.svg'
import Titulo from '@/components/Titulo.vue'
export default {
  name: 'Aviso-de-privacidad',
  data() {
      return {
          imagen: Imagen,
      }
  },
  components: {
    HelloWorld,
    Titulo,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      ocultaFooter: function(){
          this.$store.commit('ocultaFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.ocultaFooter();
      this.$store.commit('mideMenos', true);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.contenido {
    min-height: 500px;
}
.my-5 {
    margin-bottom: 150px !important;
}
a {
    color: #1900FF;
    font-weight: 600;
}
ol {
    list-style: none;
    counter-reset: item;
}
li {
    padding: 10px 10px 10px 45px;
    font-size: 18px;
    counter-increment: item;
    margin-bottom: 5px;
}
li:before {
    margin-right: 10px;
    margin-left: -50px;
    content: counter(item)'.';
    width: 1.2em;
    text-align: left;
    font-size: 30px;
    font-weight: 800;
 }
@media only screen and (max-width: 768px){
    ol {
        padding: 0;
    }
    li {
        padding: 10px 0 10px 10px;
    }
}
</style>
<style>
.contGeneral {
   /*height: 450px;*/
}
</style>
